<script>
// 组件校验及触发方式声明
import ruleTrigger from '../static/ruleTrigger'
import { RateValidate } from '../static/validate'
// 组件渲染函数
import render from '../render/index.js'
import { evalFn } from '../utils/index.js'
import intersection from 'lodash/intersection'

/**
 * 布局el-form-item
 */
const layouts = {
  colFormItem (h, scheme) {
    const config = scheme.__config__
    const formData = this[this.formConf.formModel]

    // 根据联动关系显示判断该题目是否显示
    const conditList = config.conditList.filter(item => item.relateKey && item.relateVal)
    if (conditList && conditList.length) {
      let isTrue1 = false
      let isTrue2 = false
      conditList.map(condit => {
        // 判断条件
        // 1. 如果选项是数组，只要选择数据有一项是配置选项集合即可
        // 2. 如果选项是数字，只要选择数据为配置选项相等即可
        // 3. 如果一个题型被多个条件限制时，取并集 并联动题目只显示一次
        // 条件1
        if (Array.isArray(formData[condit.relateKey])) {
          const diffList = intersection(formData[condit.relateKey], condit.relateVal) // 取交集
          const userLen = formData[condit.relateKey]?.length
          isTrue1 = userLen && diffList.length // 用户选择存在且交集数据是否与用户选择一致
        } else if (condit.relateVal.includes(formData[condit.relateKey])) {
          // 条件2
          isTrue2 = true
        }
      })
      if (!!(isTrue1 || isTrue2)) {
        scheme.__config__.display = 'block'
      } else {
        scheme.__config__.display = 'none'
      }
    }
    return showColumnItem.call(this, h, scheme, formData)
  }
}

/**
 * 展示渲染题目
 * @param {*} h 
 * @param {*} scheme 
 */
function showColumnItem (h, scheme, formData) {
  const config = scheme.__config__
  const topicData = scheme.topicData || {}
  const listeners = buildListeners.call(this, scheme)
  // 如果是单选题、多选题存在其他选项时，渲染文本框
  const collect = scheme.topicData.collect
  const curChooseVal = formData[scheme.__vModel__]
  // 单选题为单个，多选题为数组
  let optionItem = Array.isArray(curChooseVal)
    ? collect.filter(item => curChooseVal.some(e => e === item.value)).find(item => item.isExtra)
    : collect.find(item => item.value === curChooseVal)
  if (config.display === 'block') {
    return (
      <el-col span={config.span} id={scheme.__vModel__}>
        <el-form-item
          prop={scheme.__vModel__}
          class="qn-preview-parser"
        >
          <span slot="label" class="qn-component-formItem-label">
            <span class="qn-component-title">
              {topicData.name}
              {config.tag === 'el-checkbox-group' ? <span class="qn-check-box-desc">[多选]</span> : ''}
            </span>
            {topicData.subName ? <div class="qn-component-subtitle">{topicData.subName}</div> : ''}
          </span>
          <render conf={scheme} {...{ on: listeners }} />
          {/* 渲染其他选项时描述文案 */}
          {
            optionItem?.isExtra &&
            <el-input
              type="textarea"
              placeholder="请输入文案，最大长度200"
              rows={3}
              maxlength={200}
              value={optionItem.inputVal}
              onInput={event => { this.$set(optionItem, 'inputVal', event) }}
            />
          }
        </el-form-item>
      </el-col>
    )
  }
}

/**
 * 每个组件渲染
 */
function renderFormItem (h, elementList) {
  return elementList.map(scheme => {
    const config = scheme.__config__
    const layout = layouts[config.layout]
    if (layout) {
      return layout.call(this, h, scheme)
    }
    return false
  })
}

/**
 * 设置提交和取消按钮
 */
function formBtns (h) {
  const name = this.formConf.btnName || '提 交'
  return <el-col>
    <el-button size="medium" class="qn-sumbit-btn" type="primary" onClick={this.saveForm}>{name}</el-button>
  </el-col>
}

/**
 * 设置值
 */
function setValue (event, config, scheme, flag) {
  !flag && this.$set(config, 'defaultValue', event)
  this.$set(this[this.formConf.formModel], scheme.__vModel__, event)
  if (
    config.tag === 'advance-nps' ||
    config.tag === 'el-rate' ||
    config.tag === 'advance-emoj-rate' ||
    config.tag === 'el-upload'
  ) {
    const { formConf } = this
    this.$nextTick(() => {
      this.$refs[formConf.formRef].clearValidate(scheme.__vModel__)
    })
  }
}

/**
 * 设置监听属性
 */
function buildListeners (scheme) {
  const config = scheme.__config__
  const methods = scheme.on || []
  const listeners = {}


  // 监听事件触发，数据发生变化时重置隐藏组件数据值
  this.$nextTick(() => {
    this.formConf.fields.forEach(item => {
      const config = item.__config__
      const value = config.defaultValue
      if (config.display === 'none') {
        // 设置默认值时,需要保持默认落焦
        this.$set(config, 'defaultValue', Array.isArray(value) ? [] : undefined)
        // config.defaultValue = Array.isArray(value) ? [] : undefined
      }
    })
  })


  // 将on中数组转为key-value形式并绑定this和event
  methods.forEach(key => {
    const { name, value } = key
    listeners[name] = event => evalFn(value).call(this, event)
  })

  // 响应 render.js 中的 vModel $emit('input', val)
  listeners.input = event => setValue.call(this, event, config, scheme)

  return listeners
}
function bindFunctionInAttr (scheme) {
  Object.keys(scheme).forEach(key => {
    if (typeof (scheme[key]) === 'function') {
      scheme[key] = scheme[key].bind(this)
    }
  })
}

// 渲染标题与调查背景
function renderTitle (h, scheme) {
  return (
    <div class="qn-parser-title-desc">
      <div class="qn-preview-title">{scheme.title}</div>
      <div class="qn-preview-desc w-e-text-container" domPropsInnerHTML={scheme.descInfo}></div>
    </div>
  )

}

/**
 * el-form渲染
 */
function renderFrom (h) {
  const { formConf } = this
  const model = { model: this[formConf.formModel] }
  return (
    <el-row gutter={formConf.gutter}>
      <el-form
        label-position="top"
        label-width={formConf.labelWidth + 'px'}
        ref={formConf.formRef}
        rules={this[formConf.formRules]}
        size={formConf.size}
        disabled={formConf.disabled}
        props={model}
      >
        {renderTitle.call(this, h, formConf)}
        {renderFormItem.call(this, h, formConf.fields)}
        {formBtns.call(this, h)}
      </el-form>
    </el-row>
  )
}

export default {
  name: 'lower-engine-parser',
  props: {
    formConf: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    },
    type: {
      type: String,
      default: 'Page'
    },
    isSubmit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const data = {
      [this.formConf.formModel]: {},
      [this.formConf.formRules]: {}
    }
    this.initFormData(this.formConf.fields, data[this.formConf.formModel])
    this.buildRules(this.formConf.fields, data[this.formConf.formRules])
    return data
  },
  methods: {
    // 组装formConfig
    initFormData (list, formData) {
      list.forEach(item => {
        const config = item.__config__
        if (item.__vModel__) {
          // 日期设置默认值
          formData[item.__vModel__] = config.defaultValue
        }
        bindFunctionInAttr.call(this, item)
        if (config.children) this.initFormData(config.children, formData)
        if (config.layout === 'mutilFormPage') {
          item.__slot__.options.forEach(m => this.initFormData(m.children, formData))
        }
      })
    },
    // 组装rules
    buildRules (list, rules) {
      list.forEach(item => {
        const config = item.__config__
        const topicData = item.topicData
        if (Array.isArray(config.regList)) {
          if (config.required) {
            const required = { required: config.required, message: `${topicData.name}不能为空` }
            config.regList.push(required)
            // 评分组件需要额外设置自定义校验
            if (config.tag === 'el-rate') {
              config.regList.push({
                validator: RateValidate,
                trigger: ruleTrigger[config.tag]
              })
            }
          }
          rules[item.__vModel__] = config.regList.map(reg => {
            if (reg.pattern) {
              try {
                if (evalFn(reg.pattern) instanceof RegExp) {
                  reg.pattern = evalFn(reg.pattern)
                }
              } catch {
                setTimeout(() => {
                  this.$notify({
                    title: '很抱歉',
                    type: 'warning',
                    message: `${topicData.name}(${item.__vModel__})配置的正则表达式有错误， 请核查！！！`
                  })
                }, 500)
              }
            }
            reg.trigger = ruleTrigger && ruleTrigger[config.tag]
            return reg
          })
        }
        if (config.children) this.buildRules(config.children, rules)
      })
    },
    // 保存按钮
    saveForm () {
      this.$emit('saveForm', this[this.formConf.formModel])
    }
  },
  components: {
    render
  },
  render (h) {
    return renderFrom.call(this, h)
  }
}
</script>
